import React, { Component } from 'react';
import isEmpty from 'lodash/isEmpty';
import { LoaderScreen, ProductBox } from '../common';
import request from '../../request';
import Snackbar from './../common/Snackbar';
import styles from './styles.scss';
import scanImage from '../../images/sku-scan.png';
import {getTransformationUrl} from '../../utils/helper';
export default class Scan extends Component {
    state = {
        item: {},
        sku: '',
        multiPrintQty: 0,
        isMultiPrint: false,
    };

    componentDidMount = () => {
        if (this.scanInput) {
            this.scanInput.focus();
            window.addEventListener('click', this.pageClick, false);
        }
    };

    // FORCE INPUT FOCUS
    pageClick = () => {
        if (this.scanInput) {
            const x = window.scrollX,
                y = window.scrollY;
            this.scanInput.focus();
            window.scrollTo(x, y);
        }
    };

    componentWillUnmount = () => {
        window.removeEventListener('click', this.pageClick, false);
    };

    // FORCE INPUT FOCUS
    onChange = event => {
        if (event.target.value) {
            this.setState(
                {
                    sku: event.target.value,
                }
            );
        }
    };

    // FORCE INPUT FOCUS
    onKeyPress = event => {
        if (event.target.value && event.key === 'Enter') {
            this.filterScannedItem();
            event.target.value = '';
        }
    };

    filterScannedItem = () => {
        const { data } = this.props;
        const propertiesToCheck = ['sku', 'partner_sku', 'gtin'];

        const filterFunc = item => {
            let found = false;
            propertiesToCheck.forEach(element => {
                if (
                    item.hasOwnProperty(element) &&
                    item[element] === this.state.sku
                ) {
                    found = true;
                }
            });
            return found;
        };

        const item = data.lines.filter(filterFunc);

        if (!isEmpty(item)) {
            this.setState({
                err:false,
                item,
                multiPrintQty: item[0].po_qty,
            });
        }
        else this.setState({err:true});
    };


    getPrintControls = () => {
        const { isMultiPrint, item } = this.state;
        if (!isMultiPrint) {
            return (
                <React.Fragment>
                    <button
                        className={styles.primaryCta}
                        onClick={() => this.props.printLabel([item])}
                    >
                        Quick Print
                    </button>
                    <button
                        onClick={() =>
                            this.setState({
                                isMultiPrint: true,
                            })
                        }
                        className={styles.secondaryCta}
                    >
                        Multi Print
                        <i className="icon-copy" />
                    </button>
                </React.Fragment>
            );
        } else {
            return (
                <div className={styles.printControls}>
                    <input
                        value={this.state.multiPrintQty}
                        onChange={e => {
                            this.setState({
                                multiPrintQty: e.target.value,
                            });
                        }}
                    />
                    <button
                        className={styles.primaryCta}
                        onClick={() =>
                            this.props.printLabel([
                                {
                                    ...item,
                                    qty: this.state.multiPrintQty,
                                },
                            ])
                        }
                    >
                        Print Multiple
                    </button>
                </div>
            );
        }
    };

    render() {
        const { item, err, sku } = this.state;

        return (
            <div className={styles.scanContainer}>
                {isEmpty(item) ? (
                    <React.Fragment>
                        <img
                            className={styles.scanImage}
                            src={scanImage}
                            alt="SKUScan"
                        />
                        <p className={styles.scanTitle}>
                            Scan Product Barcode to View Details
                        </p>
                        <p className={styles.scanSubTitle}>
                            Please make sure you scan the barcode properly
                        </p>
                        <input
                            className={styles.sku}
                            type="text"
                            onKeyPress={(evt)=>this.onKeyPress(evt)}
                            onChange={(evt)=>this.onChange(evt)}
                            ref={input => {
                                this.scanInput = input;
                            }}
                        />
                        {
                             err ? 
                             <Snackbar msg={`${sku} is Invalid. Please try again.`}/>:''
                        }   
                    </React.Fragment>
                ) : (
                    <div className={styles.itemContainer}>
                        <div className={styles.imageContainer}>
                            <img
                                src={getTransformationUrl(
                                    item[0].image_key,
                                )}
                                alt={item[0].title_en}
                            />
                        </div>
                        <div className={styles.detailsContainer}>
                            {Object.keys(item[0]).map(key => (
                                <div className={styles.contentRow}>
                                    <label className={styles.labelText}>
                                        {key}
                                    </label>
                                    <label className={styles.valueText}>
                                        {item[0][key] ? item[0][key] : 'n/a'}
                                    </label>
                                </div>
                            ))}

                            <div className={styles.ctaContainer}>
                                {this.getPrintControls()}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Scan/index.js